<template>
  <Header12 />
  <div class="body">
    <section class="background-clair">
      <MenuTitle title="Organisme de" subTitle="formation" srcImg="/images/pages/organisme-formation.jpg"
        backgroundSpan="span-background org" />
    </section>
    <section>
      <NavLeft tab="organisme-formation" breadcrumb1="" breadcrumb2="" />
    </section>
    <section>
      <NosSessions />
    </section>
    <section>
      <DownloadCatalogue />
    </section>
    <section>
      <PreparerFormation />
    </section>
    <section class="background-clair">
      <CompteurFormations />
    </section>
    <section class="background-bleu">
      <AvisClient :idCategory="79" />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue'
import NousContacter from '@/components/emci/NousContacter/index.vue'
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
import AvisClient from '@/components/emci/AvisClient/index.vue'
import NosSessions from '@/components/emci/OrganismeFormation/NosSessions/index.vue'
import DownloadCatalogue from '@/components/emci/OrganismeFormation/DownloadCatalogue/index.vue'
import PreparerFormation from '@/components/emci/OrganismeFormation/PreparerFormation/index.vue'
import CompteurFormations from '@/components/emci/OrganismeFormation/CompteurFormations/index.vue'
useHead({
  title: "EMCI organisme de formation",
  meta: [
    {
      name: "description",
      content: "EMCI, organisme de formation reconnu se positionne comme un véritable expert dans les domaines clés du développement personnel et professionnel"
    }
  ]
})
</script>

<style scoped>
.body {

  overflow: hidden !important;
  margin-top: 120px;
}

.background-orange {
  background: #FFD186;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }

  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>